/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useContext, useState } from 'react';
import { Box, Button, Grid, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { LanguageContext } from '../../../../../../../../libs/Context';
import { RiDeleteBinLine } from 'react-icons/ri';
import { DropzoneOptions, useDropzone, Accept } from 'react-dropzone';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { catchErr, configureStore, generateThumbnailFromVideo, getDataUrlFrmLocalSystm, newNewsFeedUploadFiles, objectUrlToFile, s3DeleteNew } from '../../../../../../../../libs/HelperContent';
import Loading from '../../../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import ReactPlayer from 'react-player';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { createFeedContext } from '../../../CreationPopup';
import { onDropRejected, uploadProgressImg } from '../Common';
import heic2any from 'heic2any';

const SystemUpload = (props) =>
{
	const { uploadedFiles, setUploadedFiles, footerActn } = props;
	const { language } = useContext(LanguageContext);
	const [ loading, setLoading ] = useState<boolean>(false);
	const { createFeed } = useContext(createFeedContext);
	const previousUploadedMedia = createFeed?.media ?? [];
	const exceptLinksMedia = previousUploadedMedia?.filter((each) => each?.type !== 'link');
	// Set maxFiles based on footerActn: 5 for documents, 20 for images/videos
	const maxFiles = footerActn === 'application' ? 5 : 20;

	// Filter existing media by type based on footerActn
	const getExistingFilesByType = () =>
	{
		if (footerActn === 'application')
		{
			return exceptLinksMedia.filter((item) => item.type?.startsWith('application/'));
		}
		else if (footerActn === 'image_video' || footerActn === 'image' || footerActn === 'video')
		{
			return exceptLinksMedia.filter((item) =>
				item.type?.startsWith('image/') || item.type?.startsWith('video/')
			);
		}

		return exceptLinksMedia;
	};
	const existingFilesByType = getExistingFilesByType();

	// Size limits for different file types (only for documents)
	const FILE_SIZE_LIMITS = {
		application : 250 * 1024 * 1024 // 250MB for applications
	};
	const userData = useSelector((state:any) => state?.mysession?.session);

	const path = `${userData?.companyId}/feed`;
	const customPrefix = { public: `${userData?.companyId}/feed/` };

	// Calculate the total size of files of a specific type
	const calculateTotalSize = (files, fileType) =>
	{
		return files
			.filter((file) =>
			{
				const type = file?.type?.split('/')[0];

				return type === fileType;
			})
			.reduce((acc, curr) => acc + (curr?.size || 0), 0);
	};
	// Validate the total size of files of a specific type (only for documents)
	const validateFileSizes = (existingFiles, newFiles) =>
	{
		// Only validate document file sizes, images and videos have no size limit
		const fileTypes = [ 'application' ];

		for (const type of fileTypes)
		{
			const existingSize = calculateTotalSize(existingFiles, type);
			const newSize = calculateTotalSize(newFiles, type);
			const totalSize = existingSize + newSize;
			const limit = FILE_SIZE_LIMITS[type];

			if (totalSize > limit)
			{
				const limitInMB = limit / (1024 * 1024);
				const errorMessages = {
					application : `Document files cannot exceed ${limitInMB} MB in total`
				};

				toast.error(errorMessages[type], {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});

				return false;
			}
		}

		return true;
	};

	// Remove a file from S3 and the local state
	const handleRemoveFromS3 = async (key) =>
	{
		const removedItems = uploadedFiles?.length > 0 && uploadedFiles?.filter((item) => item?.key !== key);

		 setUploadedFiles(removedItems);

		await s3DeleteNew(key, '');
	};

	// Determine which media types to accept based on footerActn

	const onDrop = async (acceptedFiles) =>
	{
		setLoading(true);

		// Filter uploadedFiles by type (only count files of the same type)
		const getUploadedFilesByType = () =>
		{
			if (footerActn === 'application')
			{
				return uploadedFiles.filter((item) => item.type?.startsWith('application/'));
			}
			else if (footerActn === 'image_video' || footerActn === 'image' || footerActn === 'video')
			{
				return uploadedFiles.filter((item) =>
					item.type?.startsWith('image/') || item.type?.startsWith('video/')
				);
			}

			return uploadedFiles;
		};
		const uploadedFilesByType = getUploadedFilesByType();

		// Count only files of the same type (documents OR images/videos)
		const totalLength = acceptedFiles?.length + uploadedFilesByType?.length + existingFilesByType?.length;

		try
		{
			// Check number of files first
			if (totalLength > maxFiles)
			{
				toast.error(`Cannot upload more than ${maxFiles} files.`, {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});
				setLoading(false);

				return;
			}

			// Validate file sizes only for documents (images and videos have no size limit)
			if (footerActn === 'application')
			{
				const existingFiles = [ ...uploadedFiles ?? [], ...existingFilesByType ];
				const sizeValidation = validateFileSizes(existingFiles, acceptedFiles);

				if (!sizeValidation)
				{
					setLoading(false);

					return;
				}
			}

			// Process files if all validations pass
			const uploadProgress = async (file) =>
			{
				if (file?.type?.startsWith('image/') || file?.type === 'application/octet-stream')
				{
					if (file?.type !== 'image/gif' && file?.type !== 'image/heic' && file?.type !== 'image/webp' && file?.type !== 'application/octet-stream')
					{
						await uploadProgressImg(file, setLoading, path);
					}
					if (file?.type === 'image/heic' || file?.type === 'image/webp' || file?.type === 'application/octet-stream' || file?.name?.toLowerCase()?.endsWith('.heic') || file?.name?.toLowerCase()?.endsWith('.webp'))
					{
						try
						{
							let convertedBlob;

							if (file?.type === 'image/webp' || file?.name?.toLowerCase()?.endsWith('.webp'))
							{
								const fileName = file.name.replace(/\.[^/.]+$/, '.jpg');

								convertedBlob = new File([ file ], fileName, { type: 'image/jpeg' });
							}
							else
							{
								convertedBlob = await heic2any({
									blob   : file,
									toType : 'image/jpeg' });
							}

						  const blob:any = convertedBlob instanceof Blob ? convertedBlob : convertedBlob.slice();// creating a new Blob

							const fileName = file.name.replace(/\.[^/.]+$/, '.jpg');
							const jpegFile = new File([ blob ], fileName, { type: 'image/jpeg' });

							  const upload = await newNewsFeedUploadFiles([ jpegFile ], path);

							  const { url, type, key, title, name, size } = upload[0];

						  return { url, type, key, videotext: key, title, name, tab: 1, size };
						}
						catch (error)
						{
						  console.log('err cnverting to jpeg from heic------------------:', error);
						}
					}
					else
					{
						const upload = await newNewsFeedUploadFiles([ file ], path);
						const { url, type, key, title, name, size } = upload[0];

						return { url, type, key, videotext: key, title, name, tab: 1, size };
					}
				}

				const isVideo = file?.type?.startsWith('video/');
				const thumbnailD:any = {};

				if ([ 'application', 'text' ].includes(file?.type?.split('/')[0]))
				{
					const imagePath = file?.type?.split('/')[0] === 'application'
						? `/documents/${file?.name?.split('.')?.pop()}.png`
						: '/documents/txt.png';

					const generateBlob:any = await getDataUrlFrmLocalSystm(imagePath);
					const getThumbnailfile = await objectUrlToFile(generateBlob, file?.name);

					thumbnailD.thumbnailUrl = await configureStore(getThumbnailfile, customPrefix);
				}

				// if (isVideo)
				// {
				// 	try
				// 	{
				// 		const { thumbnailFile, width, height }:any = await generateThumbnailFromVideo(file);

				// 		thumbnailD.thumbnailUrl = await configureStore(thumbnailFile, customPrefix);
				// 		thumbnailD.thumbnailWdth = width;
				// 		thumbnailD.thumbailHght = height;
				// 	}
				// 	catch (err)
				// 	{
				// 		catchErr(err);
				// 	}
				// }

				if (isVideo)
				{
					console.log('Processing video:', file.type);
					try
					{
					  // More robust thumbnail generation with fallback
					  try
						{
							const { thumbnailFile, width, height }: any = await generateThumbnailFromVideo(file);

							thumbnailD.thumbnailUrl = await configureStore(thumbnailFile, customPrefix);
							thumbnailD.thumbnailWdth = width;
							thumbnailD.thumbailHght = height;
					  }
						catch (thumbnailError)
						{
							console.error('Thumbnail generation failed:', thumbnailError);
							// Fallback to a default video thumbnail
							const defaultThumbPath = '/images/video-thumbnail-default.png';
							const defaultThumb: any = await getDataUrlFrmLocalSystm(defaultThumbPath);
							const defaultThumbFile = await objectUrlToFile(defaultThumb, 'default-video-thumb.png');

							thumbnailD.thumbnailUrl = await configureStore(defaultThumbFile, customPrefix);
							thumbnailD.thumbnailWdth = 640; // default width
							thumbnailD.thumbailHght = 360; // default height
					  }
					}
					catch (err)
					{
					  console.error('Video processing error:', err);
					  throw new Error(`Unable to process video format: ${file.type}`);
					}
				  }

				// const upload = await newNewsFeedUploadFiles([ file ], path);
				// const { url, type, key, title, name, size } = upload[0];

				// return {
				// 	url,
				// 	type,
				// 	key,
				// 	videotext : key,
				// 	title,
				// 	name,
				// 	tab       : 1,
				// 	size,
				// 	thumbnail : thumbnailD?.thumbnailUrl,
				// 	...(isVideo && { height: thumbnailD?.thumbnailWdth }),
				// 	...(isVideo && { width: thumbnailD?.thumbailHght })
				// };

				// Upload the file
				try
				{
					const upload = await newNewsFeedUploadFiles([ file ], path);
					const { url, type, key, title, name, size } = upload[0];

					return {
					  url,
					  type,
					  key,
					  videotext : key,
					  title,
					  name,
					  tab       : 1,
					  size,
					  thumbnail : thumbnailD?.thumbnailUrl,
					  ...(isVideo && { height: thumbnailD?.thumbnailWdth }),
					  ...(isVideo && { width: thumbnailD?.thumbailHght })
					};
				  }
				catch (uploadError)
				{
					console.error('File upload error:', uploadError);
					throw new Error(`Failed to upload file: ${file.name}`);
				  }
			};

			const newArr = await Promise.all(
				acceptedFiles.map(async (file) =>
				{
				  try
					{
						return await uploadProgress(file);
				  }
					catch (err)
					{
						toast.error((err as Error).message || 'Error processing file', {
					  position  : toast.POSITION.TOP_RIGHT,
					  className : 'toast-message'
						});

						return null;
				  }
				})
			  );

			 // Filter out failed uploads
			 const successfulUploads = newArr.filter((item) => item !== null);

			 setUploadedFiles([ ...successfulUploads, ...uploadedFiles ]);
		}
		catch (err)
		{
			 console.error('Upload error:', err);
			 const errorMessage = (err as Error).message || 'Error processing files';

			 toast.error(errorMessage, {
			   position  : toast.POSITION.TOP_RIGHT,
			   className : 'toast-message'
			 });
		}
		finally
		{
			 setLoading(false);
		}
	};

	// Determine which media types to accept based on footerActn
	const determineAcceptedFiles = (): { accept: Accept; acceptLabel: string } =>
	{
		switch (footerActn)
		{
			case 'image':
				return {
					accept : {
						'image/png'  : [ '.png' ],
						'image/jpeg' : [ '.jpg', '.jpeg' ],
						'image/gif'  : [ '.gif' ],
						'image/webp' : [ '.webp' ]
					},
					acceptLabel : 'image/*'
				};
			case 'video':
				return {
					accept : {
					  'video/mp4'        : [ '.mp4' ],
					  'video/webm'       : [ '.webm' ],
					  'video/quicktime'  : [ '.mov' ],
					  'video/x-matroska' : [ '.mkv' ]
					},
					acceptLabel : '.mp4, .webm, .mov, .mkv'
				  };

			case 'image_video':
				return {
					accept : {
						'image/png'                : [ '.png' ],
						'image/jpeg'               : [ '.jpg', '.jpeg' ],
						'image/gif'                : [ '.gif' ],
						'image/webp'               : [ '.webp' ],
						'video/mp4'                : [ '.mp4' ],
						'video/webm'               : [ '.webm' ],
						'video/quicktime'          : [ '.mov' ],
						'video/x-matroska'         : [ '.mkv' ],
						'image/heic'               : [ '.heic' ],
						'application/octet-stream' : [ '.heic' ]
					},
					acceptLabel : 'image/*, .heic, application/octet-stream, .mp4, .webm, .mov, .mkv'
				};
			case 'application':
				return {
					accept : {
						'application/pdf'                                                           : [ '.pdf' ],
						'application/msword'                                                        : [ '.doc' ],
						'application/vnd.openxmlformats-officedocument.wordprocessingml.document'   : [ '.docx' ],
						'application/vnd.ms-excel'                                                  : [ '.xls' ],
						'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'         : [ '.xlsx' ],
						'application/vnd.ms-powerpoint'                                             : [ '.ppt' ],
						'application/vnd.openxmlformats-officedocument.presentationml.presentation' : [ '.pptx' ]
					},
					acceptLabel : '.doc, .docx, .pdf, .xls, .xlsx, .ppt, .pptx'
				};
			default:
				return {
					accept      : {},
					acceptLabel : ''
				};
		}
	};
	// const accept = footerActn === 'video' ? acceptedVideos : acceptedDocs;
	const { accept, acceptLabel } = determineAcceptedFiles();

	// Filter uploadedFiles by type for dropzone maxFiles calculation
	const getUploadedFilesByTypeForDropzone = () =>
	{
		if (footerActn === 'application')
		{
			return uploadedFiles.filter((item) => item.type?.startsWith('application/'));
		}
		else if (footerActn === 'image_video' || footerActn === 'image' || footerActn === 'video')
		{
			return uploadedFiles.filter((item) =>
				item.type?.startsWith('image/') || item.type?.startsWith('video/')
			);
		}

		return uploadedFiles;
	};
	const uploadedFilesByTypeForDropzone = getUploadedFilesByTypeForDropzone();

	const acceptFiles: DropzoneOptions = {
		maxFiles       : maxFiles - (uploadedFilesByTypeForDropzone?.length + existingFilesByType?.length),
		accept,
		onDrop,
		onDropRejected : (fileRejections) =>
		{
			onDropRejected(fileRejections, footerActn, language);
		}
	};

	 // Determine which media types to filter based on footerActn
	 const filterMediaTypes = () =>
	{
		switch (footerActn)
		{
			case 'image':
				return [ 'image' ];
			case 'video':
				return [ 'video' ];
			case 'image_video':
				return [ 'image', 'video' ];
			case 'application':
				return [ 'application' ];
			default:
				return [];
		}
	};

	// Filter media types based on footerActn
	const filteredMediaTypes = filterMediaTypes();
	// Render image or document based on media type
	const renderImgDocs = (mediaD, extensionformat) =>
	{
		return (
			mediaD?.type.split('/')[0] === 'image'
				? (
					<Box
						component='img'
						src={mediaD?.url}
						alt={`img-${mediaD?.key}`}
						sx={{ width: '100%', borderRadius: '8px', height: '100%' }}
					/>
				)
				: (
					<LazyLoadImage
						src={`/documents/${extensionformat}.png`}
						alt='document'
						delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME}
						effect={process.env.REACT_APP_EFFECT}
						width={`${process.env.REACT_APP_IMG_WIDTH}%`}
						height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
					/>
				)

		);
	};

	// Dropzone hooks
	const { getRootProps, getInputProps } = useDropzone(acceptFiles);

	return (
		<Grid container>
			{loading && <Loading/>}
			<Grid item xs={12} alignItems='start' display={'flex'} pb='var(--pixel4)'>
				<Stack flexDirection='row' alignItems={'center'} justifyContent={'space-between'} width={'var(--percent100)'}>
					<Typography variant='inherit' fontSize={'var(--pixel16)'} fontWeight='var(--font500)' color={'rgba(96, 97, 98, 1)'} pb='var(--pixel4)'>{language?.uploadFiles}</Typography>
					{uploadedFiles?.length > 0 && uploadedFiles?.length < maxFiles && (
						<Typography variant='inherit' fontSize={'var(--pixel12)'} fontWeight='var(--font500)' color={'rgba(166, 166, 166, 1)'} sx={{ cursor: 'pointer' }}>
							{uploadedFiles?.length > 0 && uploadedFiles?.length < maxFiles && (
								<Grid item xs={12} alignItems='flex-end' display='flex' {...getRootProps()}>
									<Button variant='text' disableElevation>
										{language?.browsefile}{`/${language?.dragfiles}`}
									</Button>
								</Grid>
							)}
						</Typography>)}
				</Stack>
			</Grid>
			<Grid item xs container>
				{/* <Stack direction='row'> */}
				<Box
					display='flex' flexWrap={'wrap'}
					sx={{ border: '2px dotted rgb(96 97 98 / 73%)', borderRadius: '13px', cursor: 'pointer', width: 'var(--percent100)', height: 'auto', aspectRatio: '16 / 9' }}
					{...getRootProps()}
				>
					<input
						{...getInputProps()}
						accept={acceptLabel}
					/>
					{uploadedFiles?.filter((media) =>
						media?.tab === 1 &&
						filteredMediaTypes.includes(media?.type?.split('/')[0])
					)?.length === 0
						? (
							<Stack spacing={0.5} direction='column' alignItems='center' justifyContent='center' width={'var(--percent100)'}>
								<Box
									component='img'
									src='/images/uploadIcon.svg'
									alt='check_icon'
									sx={{ width: 'auto', height: 'var(--pixel32)' }}
								/>
								<Typography
									variant='inherit'
									fontSize={'var(--pixel16)'}
									fontWeight='var(--font500)'
								>
									{/* {uploadedFiles?.length > 0 &&
									uploadedFiles?.length < 5 && (
										<Grid
											item xs={12}
											alignItems='flex-end'
											display='flex'
										>
											<Button variant='text' disableElevation>
												{language?.browsefile}
											</Button>
										</Grid>)} */}
									{language?.dragfiles}
								</Typography>
								<Typography
									fontSize={'var(--pixel16)'}
									fontWeight='var(--font400)'
								>
									{language?.share} {footerActn === 'application' ? `${language?.documents}` : (footerActn === 'image_video' ? 'Image/Video' : footerActn)} {footerActn === 'application' ? `${language?.uploadLimitDoc}` : `${language?.cannotUploadMoreThan20Files}`}
								</Typography>
								<Typography fontSize={'var(--pixel16)'} fontWeight='var(--font500)'>{language?.or}</Typography>
								<Button variant='contained' sx={{ color: 'var(--whiteColor)' }} disableElevation >{language?.browsefile}
									{/* <input type='file' ref={fileInputRef} style={{ display: 'none' }} /> */}
								</Button>
							</Stack>
						)
						: (
							uploadedFiles?.filter((media) =>
								media?.tab === 1 &&
								filteredMediaTypes.includes(media?.type?.split('/')[0])
							)?.map((mediaD?:any) =>
							{
								const extensionformat = mediaD?.key?.split('.').pop();

								return (
									<Grid onClick={(e) => e.stopPropagation()} item
										key={mediaD?.key} xs={12} sm={6} md={4} lg={3} sx={{ padding: 'var(--pixel8)', position: 'relative' }}
									>
										<Grid
											sx={{
												width        : '130px',
												height       : '100px',
												display      : 'inline-flex',
												borderRadius : 'var(--pixel8)',
												padding      : 'var(--pixel8)',
												overflow     : 'hidden',
												aspectRatio  : '4 / 3',
												border       : '1px solid var(--boxshadow0-5)',
												'& img'      : {
													width        : '100%',
													height       : '100%',
													objectFit    : 'contain',
													borderRadius : 'var(--pixel8)'
												}
											}}
										>
											{(mediaD?.type.split('/')[0] === 'video')
												? (
													<ReactPlayer
														url={mediaD.url}
														className='reactPlayerWidth'
														width={'var(--percent100)'}
														height={'var(--percent100)'}
													/>
												)
												: renderImgDocs(mediaD, extensionformat)}
											<Box
												sx={{
													position        : 'absolute',
													top             : 10,
													right           : 10,
													width           : 24,
													height          : 24,
													borderRadius    : 'var(--percent50)',
													backgroundColor : 'rgba(255, 255, 255, 1)',
													display         : 'flex',
													alignItems      : 'center',
													justifyContent  : 'center'
												}}
											>
												<Tooltip title={language?.delete} placement='top'>
													<IconButton onClick={() => handleRemoveFromS3(mediaD?.key)}>
														<RiDeleteBinLine fontSize='var(--pixel16)' className='lightTxt' />
													</IconButton>
												</Tooltip>

											</Box>
										</Grid>
										<Box sx={{ width: 'var(--percent100)', overflow: 'hidden' }}>
											<Tooltip title={mediaD?.name}>
												<Typography
													fontSize={14}
													sx={{
														whiteSpace   : 'nowrap',
														overflow     : 'hidden',
														textOverflow : 'ellipsis',
														width        : 'var(--percent100)',
														lineHeight   : 1.4
													}}
												>
													{mediaD?.name}
												</Typography>
											</Tooltip>
										</Box>
									</Grid>);
							}))}

				</Box>
				{/* </Stack> */}
			</Grid>
		</Grid>
	);
};

export default SystemUpload;
